$('.hc-annoumcements-slider').slick({
  dots: false,
  infinite: true,
  autoplay: true,
  slidesToShow: 1,
  prevArrow: '<div class="hc-arrow-left"><i class="fa fa-angle-left" aria-hidden="true"></i></div>',
  nextArrow: '<div class="hc-arrow-right"><i class="fa fa-angle-right" aria-hidden="true"></i></div>',
});

(function () {
  function getValue(wrapper) {
    const el = wrapper && wrapper.querySelector(".hc-swatch-value");
    return el ? el.textContent.trim() : "";
  }
  function setCurrent(container, value) {
    const el = container.querySelector(".hc-swatch-value-current");
    if (el) el.textContent = value || "";
  }
  function getActiveValue(container) {
    const active = container.querySelector(".hc-swatch-wrapper.hc-swatch-active");
    return getValue(active);
  }
  function setActive(container, swatch) {
    container.querySelectorAll(".hc-swatch-wrapper").forEach(s => s.classList.remove("hc-swatch-active"));
    swatch.classList.add("hc-swatch-active");
    setCurrent(container, getValue(swatch));
  }
  function init(container) {
    const list = container.querySelector(".hc-related-products");
    if (!list) return;

    setCurrent(container, getActiveValue(container));

    list.addEventListener("mouseover", function (e) {
      const swatch = e.target.closest(".hc-swatch-wrapper");
      if (!swatch || !list.contains(swatch)) return;
      const val = getValue(swatch);
      if (val) setCurrent(container, val);
    });

    list.addEventListener("mouseout", function (e) {
      const swatch = e.target.closest(".hc-swatch-wrapper");
      if (!swatch || !list.contains(swatch)) return;
      const to = e.relatedTarget;
      if (to && swatch.contains(to)) return; // still inside same swatch
      setCurrent(container, getActiveValue(container));
    });

    list.addEventListener("mousedown", function (e) {
      const a = e.target.closest(".hc-swatch-wrapper a");
      if (!a || !list.contains(a)) return;
      const swatch = a.closest(".hc-swatch-wrapper");
      if (swatch) setActive(container, swatch);
      // no preventDefault -> navigation allowed
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => {
      document.querySelectorAll(".hc-related-wrapper").forEach(init);
    });
  } else {
    document.querySelectorAll(".hc-related-wrapper").forEach(init);
  }
})();

(function(){
  var moTimer;

  function bindSwatches(){
    document.querySelectorAll('.grid-view-item-image[data-product]').forEach(function(card){
      var id = card.getAttribute('data-product');
      var img = card.querySelector('.responsive-image-wrapper img.js');
      if (!img) return;

      if (!img.dataset.originalSrc) {
        img.dataset.originalSrc = img.getAttribute('src') || '';
        img.dataset.originalSrcset = img.getAttribute('srcset') || '';
        img.dataset.originalSizes = img.getAttribute('sizes') || '';
      }

      var swatches = document.querySelectorAll('.hc-swatch-wrapper-coll .hc-swatch-coll[data-product="' + id + '"]');
      swatches.forEach(function(sw){
        if (sw.dataset.hcBound) return;
        sw.dataset.hcBound = '1';
        sw.addEventListener('mouseenter', function(){
          swatches.forEach(function(s){
            var w = s.closest('.hc-swatch-wrapper-coll');
            if (w) w.classList.remove('hc-swatch-active-coll');
          });
          var wrap = sw.closest('.hc-swatch-wrapper-coll');
          if (wrap) wrap.classList.add('hc-swatch-active-coll');

          var url = sw.getAttribute('data-image');
          if (!url) {
            var bg = sw.style.backgroundImage;
            var m = bg && bg.match(/url\((['"]?)(.*?)\1\)/);
            url = m ? m[2] : '';
          }
          if (url) {
            img.setAttribute('src', url);
            img.removeAttribute('srcset');
          }
        });
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function(){
    bindSwatches();
    if ('MutationObserver' in window) {
      new MutationObserver(function(){
        clearTimeout(moTimer);
        moTimer = setTimeout(bindSwatches, 80);
      }).observe(document.body, { childList: true, subtree: true });
    }
  });
})();

(function(){
  if (!window.jQuery) return;
  jQuery(function($){
    var moTimer;

    function slidesToShowForWidth(vw){
      if (vw < 520) return 2;
      if (vw < 768) return 3;
      if (vw < 1024) return 4;
      if (vw < 1280) return 5;
      return 6;
    }

    function markFewSwatches(){
      var vw = window.innerWidth || document.documentElement.clientWidth || 1920;
      var threshold = slidesToShowForWidth(vw);
      $('.hc-related-products-coll').each(function(){
        var $wrap = $(this);
        if ($wrap.hasClass('slick-initialized')) return;
        var count = $wrap.children('.hc-swatch-wrapper-coll').length;
        if (count < threshold) {
          $wrap.addClass('hc-no-slick');
        } else {
          $wrap.removeClass('hc-no-slick');
        }
      });
    }

    function initSwatchSliders(){
      markFewSwatches();
      $('.hc-related-products-coll').not('.slick-initialized').slick({
        slidesToShow: 6,
        slidesToScroll: 1,
        infinite: false,
        dots: false,
        arrows: true,
        prevArrow: '<div class="hc-arrow-left"><i class="fa fa-angle-left" aria-hidden="true"></i></div>',
        nextArrow: '<div class="hc-arrow-right"><i class="fa fa-angle-right" aria-hidden="true"></i></div>',
        swipeToSlide: true,
        waitForAnimate: false,
        responsive: [
          { breakpoint: 1280, settings: { slidesToShow: 5 } },
          { breakpoint: 1024, settings: { slidesToShow: 4 } },
          { breakpoint: 768,  settings: { slidesToShow: 3 } },
          { breakpoint: 520,  settings: { slidesToShow: 2 } }
        ]
      });
    }

    initSwatchSliders();
    jQuery(window).on('resize', markFewSwatches);

    if ('MutationObserver' in window) {
      new MutationObserver(function(){
        clearTimeout(moTimer);
        moTimer = setTimeout(function(){
          markFewSwatches();
          initSwatchSliders();
        }, 80);
      }).observe(document.body, { childList: true, subtree: true });
    }
  });
})();


